import styles from './FiltersOverlayStartPage.module.scss';

import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Divider } from '@work4all/components/lib/dataDisplay/divider/Divider';

import { FilterOverlayContext } from '../../FiltersOverlayV8';
import { FilterCardListV8 } from '../filter-card-list/FilterCardListV8';
import { FilterSubGroupListV8 } from '../filter-sub-group-list/FilterSubGroupListV8';

export const FiltersOverlayStartPageV8: React.FC = () => {
  const { additionalFilters: activeFilters } = useContext(FilterOverlayContext);

  const { t } = useTranslation();

  return (
    <div className={styles.content}>
      <FilterCardListV8 cols={activeFilters} />

      <div className={styles.secondaryFiltersWrap}>
        <Divider title={t('COMMON.ADD_FILTER')}></Divider>
      </div>
      <FilterSubGroupListV8 subgroupPath={[]} />
    </div>
  );
};
